import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormBuilder, FieldArray, Validators} from 'react-reactive-form';
import renderer from './renderers';
import validation from '../../../utils/validation';

class IdentifiersEditControl extends Component {
    constructor(props){
        super(props);

        this.addNewItem = this.addNewItem.bind(this);
        this.removeItem = this.removeItem.bind(this);
    };

    static initArray(items, form) {
        var result = [];
        if (items) {
            for (var item of items) {
                var ni = {
                    fieldName: ['type' in item ? item.type : '', [[Validators.pattern(validation.datePattern)]]],
                    value: 'value' in item ? item.value : '',
                    endDate: ['endDate' in item ? item.endDate : '', [Validators.pattern(validation.datePattern)]]
                    
                }
                result.push(FormBuilder.group(ni));
            }
        }
        return result;
    }

    addNewItem() {
        console.log('Adding to field => ', this.props.name);
        const arr = this.props.form.get(this.props.name);

        arr.push(FormBuilder.group({
            fieldName: '',
            value: ''
        }));
    }

    removeItem(index) {
        console.log('Removing from field => ', this.props.name, ' index => ', index);
        const control = this.props.form.get(this.props.name);
        control.removeAt(index);
    }

    render() {
        console.log(this.props.form)
        return (
            <FieldArray name={this.props.name} 
                render={renderer.metaDataArray} 
                meta={{
                    label: this.props.label,
                    addLabel: this.props.addLabel,
                    onAdd: () => {this.addNewItem()},
                    onRemove: (index) => {this.removeItem(index)},
                    form: this.props.form
                }}
            />
        );
    };
}

IdentifiersEditControl.propTypes = {
    name: PropTypes.string.isRequired,
    form: PropTypes.object.isRequired,
    label: PropTypes.string,
    addLabel: PropTypes.string
};

export default IdentifiersEditControl;

